var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSnippetOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35206 16.6863C4.70036 16.39 5.20527 16.3678 5.57832 16.6322L8 18.3489L10.4217 16.6322C10.7681 16.3866 11.2319 16.3866 11.5783 16.6322L14 18.3489L16.4218 16.6322C16.7948 16.3678 17.2997 16.39 17.648 16.6863L19 17.8364V3H3V17.8365L4.35206 16.6863ZM3 19.1493L2.97704 19.1689L2.763 19.3509L2.49438 19.5794C2.29956 19.7452 2 19.6067 2 19.3509V18.9983V18.7173V18.6871V3C2 2.44772 2.44772 2 3 2H19C19.5523 2 20 2.44772 20 3V18.6871V18.7172V18.9982V19.3509C20 19.6066 19.7004 19.7451 19.5056 19.5794L19.237 19.3509L19.023 19.1688L19 19.1493L17.0001 17.448L14.2313 19.4107C14.0928 19.5089 13.9072 19.5089 13.7687 19.4107L11 17.448L8.23133 19.4107C8.09275 19.5089 7.90725 19.5089 7.76867 19.4107L5 17.448L3 19.1493Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8L15 8",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L15 11",
    stroke: "#EEEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSnippetOutline);
export default __webpack_public_path__ + "static/media/ic_snippet_outline.e3d5b58981fbe07b8f3959a1771e9b6b.svg";
export { ForwardRef as ReactComponent };